"use client";

import { BrandLogoMark } from "@v1/ui/brand-logo-mark";
import { useTranslations } from "next-intl";
import Link from "next/link";
import type { ReactElement } from "react";
import { CAREERS_CONTENT } from "./careers-content";
import { useCareersLanguage } from "./careers-language-context";

/** Sticky slim top bar (funnel style): logo left, language toggle + jobs CTA
 * right. Language toggle routes between /careers and /careers/en. */
export function CareersTopbar(): ReactElement {
  const tI18n = useTranslations("public.careersTopbar");
  const { lang, toggle } = useCareersLanguage();
  const t = CAREERS_CONTENT[lang].bar;

  return (
    <header className="dvf-bar">
      <div className="c2-bar-inner">
        <Link href="/" className="dvf-bar-logo">
          <BrandLogoMark width={24} height={24} variant="website" />
        </Link>

        <div className="c2-bar-actions">
          <button
            type="button"
            className="c2-lang"
            onClick={toggle}
            aria-label={tI18n("spracheWechselnSwitchLanguage")}
          >
            <span
              className={
                lang === "de" ? "c2-lang-opt c2-lang-opt-on" : "c2-lang-opt"
              }
            >
              {tI18n("de")}
            </span>
            <span
              className={
                lang === "en" ? "c2-lang-opt c2-lang-opt-on" : "c2-lang-opt"
              }
            >
              {tI18n("en")}
            </span>
          </button>
          <Link href="#jobs" className="c2-btn">
            <span className="c2-bar-cta-full">{t.cta}</span>
            <span className="c2-bar-cta-short">{t.ctaShort}</span>
          </Link>
        </div>
      </div>
    </header>
  );
}
